export default __webpack_public_path__ + "static/media/Header.8caa8c29.svg";